import React from "react";
import { connect } from "react-redux";
import { ManagerJson } from "../../../DynamicFormsJson/MastersJSON/manager";
import { getAreaByUserType } from "../../../Slice/area.slice";
import {
  getManagerAllUpdatedNew,
  getAllSalesTeam,
  getUpdatedManagerNew,
} from "../../../Slice/manager.slice";
import { getStockStakeHolderType } from "../../../Slice/stockStakeHolderType.slice";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { ManagerColumns } from "../../../tableColumns/table-columns";
import { getRegionNew } from "../../../Slice/region.slice";
import { getStateByRegion } from "../../../Slice/state.slice";
import { getZoneByState } from "../../../Slice/zone.slice";
import { getDistrictByZone } from "../../../Slice/district.slice";
import { getTalukaByDistrictPost } from "../../../Slice/taluka.slice";
import { getAreaByTalukaPostBodyUpdated } from "../../../Slice/area.slice";
import swal from "sweetalert";
import endpoint from "../../../config/endpoints";
import {
  deleteFailedMsg,
  deletemsg,
  deleteWarningMsg,
  FailTogenerateCredentialMsg,
  generateCredentialMsg,
  noInternetMsg,
  saveFailedMsg,
  sendCredentialMsg,
  serverMsg,
} from "../../../config/messageconstant";
import { apiDelete, apiGet, apiPost } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import DynamicTabwiseTable from "../../../components/dynamicscreens/DynamicTabwiseTable";
import { compose } from "recompose";
import { withRouter } from "../../../components/withRouter";
class SalesExecutiveTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLog: true,
      moduleObjDataObj: {},
      dynamicMasterData: {
        stockStakeHolderTypeDetail:
          this.props.stockStakeHolderType?.stockStakeHolderType,
        stateDetail: this.props.stateList?.stateByRegion,
        zoneDetail: this.props.zoneList?.zoneByState,
        districtDetail: this.props.districtList?.districtByZone,
        talukaDetail: this.props.talukaList?.talukaByDistrict,
        areaDetail: this.props.areaList?.areaByTaluka,
        managerListInActive: this.props.managerList?.manager.filter(
          (row) => row.isActive == 0
        ),
        managerListActive: this.props.managerList?.manager.filter(
          (row) => row.isActive == 1
        ),
      },
      tabValue: 1,
      moduleObjDataObj: {},
      isLog: true,
      preventToAddSalesTeam: false,
      tabList: [
        {
          label: "Active",
          allyProps: 0,
          columns: ManagerColumns,
          showExcelDownload: false,
          changeExcelURL: "sales-executive-data",
          isActionColActive: true,
          value: "managerListActive",
          searchList: ManagerJson.searchList,
        },
        {
          label: "InActive",
          allyProps: 1,
          columns: ManagerColumns,
          showExcelDownload: false,
          changeExcelURL: "sales-executive-data",
          isActionColActive: true,
          value: "managerListInActive",
          searchList: ManagerJson.searchList,
        },
      ],
    };
  }
  async componentDidMount() {
    const {
      getRegionNew,
      getAreaByUserType,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {

      localStorage.removeItem("salesTeamIdForAddLeave");

      const userTypeId = localStorage.getItem("userTypeId");

      if (
        localStorage.getItem("multipleRegionForManager") &&
        localStorage.getItem("multipleRegionForManager") == 1
      ) {
        this.setState((prevState) => ({
          tabList: prevState.tabList.map((tab) => ({
            ...tab,
            searchList: userTypeId == 3 ? [] : ManagerJson.searchListForMultipleRegion,
          })),
        }));
      }

      if (userTypeId == 1 || userTypeId == 6) {
        showLoador({ loador: true });
        await getRegionNew().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      } else {
        showLoador({ loador: true });
        await getAreaByUserType().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }



      await this.getTableData();
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.stockStakeHolderType !== nextProps.stockStakeHolderType) {
      if (
        this.props.stockStakeHolderType?.stockStakeHolderType !==
        nextProps.stockStakeHolderType?.stockStakeHolderType
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockStakeHolderTypeDetail:
              nextProps.stockStakeHolderType?.stockStakeHolderType,
          },
        });
      }
    }
    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }
    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }
    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }
    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }
    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaByTaluka,
          },
        });
      }
    }
    if (this.props.managerList !== nextProps.managerList) {
      if (this.props.managerList?.manager !== nextProps.managerList?.manager) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            managerListActive: nextProps.managerList?.manager
              .filter((row) => row.isActive == 1)
              .map((rowData, index) => {
                return { ...rowData, index: index + 1 };
              }),
            managerListInActive: nextProps.managerList?.manager
              .filter((row) => row.isActive == 0)
              .map((rowData, index) => {
                return { ...rowData, index: index + 1 };
              }),
          },
        });
      }
    }
  }

  getTabValue = (rowValue) => {
    this.setState({
      tabValue: rowValue == 0 ? 1 : 0,
    });
  };

  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrictPost,
      getAreaByTalukaPostBodyUpdated,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      console.log(data);
      if (data.region && data.region != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.region }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.state && data.state != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.state }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.zone && data.zone != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.zone }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.district && data.district != "") {
        let districtIdsByPost = {
          districtIds: data.district,
        };

        showLoador({ loador: true });
        await getTalukaByDistrictPost({ districtIds: districtIdsByPost }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.taluka && data.taluka != "") {
        let talukaJson = {
          talukaIds: data.taluka,
        };
        showLoador({ loador: true });
        await getAreaByTalukaPostBodyUpdated({ talukaIds: talukaJson }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchData = async (data) => {
    const { getUpdatedManagerNew, showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      if (
        data.stockStakeHolderType != null &&
        data.stockStakeHolderType != "" &&
        data.area != null &&
        data.area != ""
      ) {
        let managerJson = {
          stockStakeHolderTypeId: data.stockStakeHolderType,
          areaIds: data.area,
        };

        showLoador({ loador: true });
        await getUpdatedManagerNew({ managerJson: managerJson }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      } else {
        this.getTableData();
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onClickApply = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { isLog, moduleObjDataObj } = this.state;
    swal({
      title: "Are you sure?",
      text: sendCredentialMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (navigator.onLine) {
          this.props.showLoador({ loador: true });
          apiGet({
            url: endpoint.salesExecutive + "/" + rowData.id + "/password-reset",
          }).then(({ success }) => {
            if (success) {
              if (isLog) {
                if (rowData !== null) {
                  let updatedJsonToSend = JSON.stringify(rowData);

                  let dataToSaveForMLog = {
                    module: {
                      moduleId: moduleObjDataObj.moduleId,
                    },
                    subModule: {
                      subModuleId: moduleObjDataObj.subModuleId,
                    },
                    operationType: 1,
                    type: 1,
                    operationPerformId: rowData.id,
                    updatedJson: updatedJsonToSend,
                  };

                  showLoador({ loador: true });
                  apiPost({
                    url: endpoint.mlog,
                    postBody: dataToSaveForMLog,
                  }).then(({ success }) => {
                    showLoador({ loador: false });
                    if (success) {
                    } else {
                      showNotification({
                        msg: saveFailedMsg,
                        severity: "error",
                      });
                    }
                  });
                }
              }

              this.props.showLoador({ loador: false });
              this.props.showNotification({
                msg: generateCredentialMsg,
              });
            } else {
              this.props.showNotification({
                msg: FailTogenerateCredentialMsg,
                severity: "error",
              });
              this.props.showLoador({ loador: false });
            }
          });
        }
      } else {
        this.props.showNotification({ msg: noInternetMsg, severity: "error" });
      }
    });
  };

  getTableData = async () => {
    const {
      getManagerAllUpdatedNew,
      getAllSalesTeam,
      getStockStakeHolderType,
      showLoador,
      showNotification
    } = this.props;

    const moduleObjData = localStorage.getItem("moduleObj");
    const moduleObjDataObj =
      moduleObjData != null ? JSON.parse(moduleObjData) : {};

    this.setState({ moduleObjDataObj });

    if (localStorage.getItem("isShowSalesTeamModuleOverTheManager") &&
      localStorage.getItem("isShowSalesTeamModuleOverTheManager") == 1) {

      showLoador({ loador: true });
      await getAllSalesTeam().then(({ response, success }) => {
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {

          const activeSalesTeamCount = response.filter((row) => row.isActive == 1).length;

          const noOfLicenseCount = localStorage.getItem("noOfLicenseCount") !== null ?
            localStorage.getItem("noOfLicenseCount") : 5000;


          if (activeSalesTeamCount >= noOfLicenseCount) {
            this.setState({ preventToAddSalesTeam: true });
          } else {
            this.setState({ preventToAddSalesTeam: false });
          }
        }
      });

      await getStockStakeHolderType({ userTypeIds: "3,4" }).then(({ success }) => {
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
      showLoador({ loador: false });

    } else {
      showLoador({ loador: true });
      await getManagerAllUpdatedNew().then(({ success }) => {
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      await getStockStakeHolderType({ userTypeIds: 3 }).then(({ success }) => {
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
      showLoador({ loador: false });

    }
  };

  rowDelete = (rowData) => {
    const { showNotification, showLoador } = this.props;
    swal({
      title: "Are you sure?",
      text: deleteWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (rowData.id) {
          showLoador({ loador: true });
          apiDelete({
            url: endpoint.salesExecutive + "/" + rowData.id,
          }).then(({ data, success }) => {
            showLoador({ loador: false });
            if (success) {
              if (data && data.data && data.data.statusCode == 200) {
                showNotification({ msg: deletemsg });
                window.location.reload();
              } else {
                showNotification({ msg: deleteFailedMsg, severity: "error" });
              }
            } else {
              showNotification({
                msg: serverMsg,
                severity: "error",
              });
            }
          });
        }
      }
    });
  };

  rowCalenderDetails = (rowData) => {
    this.props.navigate("/add-sales-team-leave/" + rowData.id);
  }

  render() {
    const { managerList } = this.props;
    const { dynamicMasterData, tabList, preventToAddSalesTeam } = this.state;

    const isShowLeaveIconAtSalesTeam =
      localStorage.getItem("isShowLeaveIconAtSalesTeam") !== null ? localStorage.getItem("isShowLeaveIconAtSalesTeam") : 0;

    const isShowSendCredentialIcon =
      localStorage.getItem("isShowSendCredentialIcon") !== null ? localStorage.getItem("isShowSendCredentialIcon") : 1;

    return (
      <>
        <DynamicTabwiseTable
          dynamicMasterData={dynamicMasterData}
          searchList={localStorage.getItem("userTypeId")
            && localStorage.getItem("userTypeId") == 3 ? [] : ManagerJson.searchList}
          showView={true}
          formPathView={ManagerJson.formPathView}
          getListById={this.getListById}
          formPath={ManagerJson.formPath}
          screenTitle={localStorage.getItem("isShowSalesTeamModuleOverTheManager") &&
            localStorage.getItem("isShowSalesTeamModuleOverTheManager") == 1 ? "Sales Team" : ManagerJson.screenTitle}
          fieldMeta={ManagerJson.fieldMeta}
          showPdfDownload={ManagerJson.showPdfDownload}
          showExcelDownload={true}
          isExcelStaticUrl={true}
          filterDataExcel={true}
          pdfFileName={ManagerJson.pdfFileName}
          excelFileName={ManagerJson.excelFileName}
          showAddButton={preventToAddSalesTeam ? false : true}
          tableColumnsToFilter={ManagerJson.tableColumnsToFilter}
          tableColumns={ManagerColumns}
          tableData={managerList?.manager}
          apiBaseURL={ManagerJson.apiBaseURL}
          callApi={false}
          isActiveURL={ManagerJson.isActiveURL}
          showAddButtonInTable={false}
          onClickAdd={this.onClickAdd}
          openFormPath={ManagerJson.openFormPath}
          searchButtonGrid={ManagerJson.searchButtonGrid}
          getTableDataById={true}
          rowStatusTrue={false}
          onSearchData={this.onSearchData}
          tabList={tabList}
          changeExcelURL={ManagerJson.excelUrl}
          isNote={true}
          isNoteValue={localStorage.getItem("isShowSalesTeamModuleOverTheManager") &&
            localStorage.getItem("isShowSalesTeamModuleOverTheManager") == 1 ? "Add Sales Team & Details" : "Add Sales Manager & Details"}
          rowList={dynamicMasterData}
          formPathStatic={false}
          showHeadEdit={true}
          staticEdit={false}
          deleteStaticTrue={true}
          getTabValue={this.getTabValue}
          showHeadDelete={true}
          showPegination={true}
          showApplyCredintial={isShowSendCredentialIcon == 1 ? true : false}
          rowApply={this.onClickApply}
          getTableData={this.getTableData}
          rowDelete={this.rowDelete}
          showCalenderIcon={isShowLeaveIconAtSalesTeam == 1 ? true : false}
          rowCalenderDetails={this.rowCalenderDetails}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  managerList: state.manager,
  stockStakeHolderType: state.stockStakeHolderType,
  areaList: state.area,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
});
const mapDispatchToProps = {
  getStateByRegion,
  getZoneByState,
  getStockStakeHolderType,
  getRegionNew,
  getAreaByUserType,
  getDistrictByZone,
  getTalukaByDistrictPost,
  getAreaByTalukaPostBodyUpdated,
  showLoador,
  getManagerAllUpdatedNew,
  showNotification,
  getUpdatedManagerNew,
  getAllSalesTeam,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SalesExecutiveTable);